import { TYPES } from 'action-types/exportJob';
import {
    IExportJobDetail, EmptyDocumentDetail, IExportDetailsClr, IExportDetailsCbl,
    IExportDetailsBookingAndCargo, IExportDetailsEts, IExportDetailsCustomerInvoice,
    IExportDetailsCostAndRevenue, IExportJobs, ISalesOrders, INftpBillableResponse
} from './models';

interface IAction {
    readonly type: string;
    readonly exportJobDetails: IExportJobDetail;
    readonly exportDetailsCostAndRevenue: IExportDetailsCostAndRevenue[];
    readonly exportDetailsBooking: IExportDetailsBookingAndCargo;
    readonly exportDetailsClr: IExportDetailsClr[];
    readonly exportDetailsCbl: IExportDetailsCbl[];
    readonly exportDetailsEts: IExportDetailsEts[];
    readonly exportDetailsCustomerInvoice: IExportDetailsCustomerInvoice[];
    readonly exportJobs: IExportJobs;
    readonly errors: string;
    readonly documentDropdownData: [];
    readonly salesOrderResponse: ISalesOrders;
    readonly salesOrderId: number;
    readonly bulkDownloadString: any;
    readonly reconsiliationPODetails: any;
    readonly sendCreateSalesOrderExportResult: any;
    readonly nftpBillableResponse: INftpBillableResponse | null;
}
export interface IExportJobState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly detailsPendingError: string;
    readonly exportJobDetails: IExportJobDetail;
    readonly exportDetailsCostAndRevenue: IExportDetailsCostAndRevenue[];
    readonly isExportDetailsCostAndRevenueLoading: boolean;
    readonly exportDetailsBooking: IExportDetailsBookingAndCargo;
    readonly exportDetailsClr: IExportDetailsClr[];
    readonly exportDetailsCbl: IExportDetailsCbl[];
    readonly exportDetailsEts: IExportDetailsEts[];
    readonly exportDetailsCustomerInvoice: IExportDetailsCustomerInvoice[];
    readonly exportJobs: IExportJobs;
    readonly documentDropdownData: [];
    readonly salesOrderResponse: ISalesOrders;
    readonly salesOrderId: number;
    readonly bulkDownloadString: any;
    readonly isDownloadLoading: boolean;
    readonly reconsiliationPODetails: any;
    readonly sendCreateSalesOrderExportResult: any;
    readonly nftpBillableResponse: INftpBillableResponse | null;
    readonly isNftpBillableLoading: boolean;
}

export const defaultState: IExportJobState = {
    isFetchDataLoading: false,
    isFetchDataError: false,
    isExportDetailsCostAndRevenueLoading: false,
    detailsPendingError: '',
    exportJobDetails: EmptyDocumentDetail,
    exportDetailsBooking: {
        bookings: [],
        totalQuantity: 0,
        totalWeight: 0,
        totalVolume: 0,
        totalPackages: 0
    },
    exportDetailsCostAndRevenue: [],
    exportDetailsClr: [],
    documentDropdownData: [],
    exportDetailsCbl: [],
    exportDetailsEts: [],
    exportDetailsCustomerInvoice: [],
    exportJobs: {
        pageNumber: 1,
        page: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    salesOrderResponse: {
        page: 1,
        pageSize: 0,
        totalCount: 0,
        data: []
    },
    salesOrderId: 0,
    bulkDownloadString: '',
    isDownloadLoading: false,
    reconsiliationPODetails: [],
    sendCreateSalesOrderExportResult: null,
    nftpBillableResponse: null,
    isNftpBillableLoading: false,
};

export const reducer = (state: IExportJobState = defaultState, action: IAction): IExportJobState => {
    switch (action.type) {
        case TYPES.RESET_EXPORT_JOB.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                detailsPendingError: ''
            };
        case TYPES.RESET_EXPORT_JOB.FULFILLED:
            return {
                ...state,
                exportJobs: action.exportJobs && action.exportJobs.result?.length === 0 ? defaultState.exportJobs : action.exportJobs
            };
        case TYPES.FETCH_EXPORT_JOB.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                exportJobs: defaultState.exportJobs
            };
        case TYPES.FETCH_EXPORT_JOB.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                exportJobs: action.exportJobs
            };
        case TYPES.FETCH_EXPORT_JOB.REJECTED:
            return {
                ...state,
                isFetchDataError: true,
                isFetchDataLoading: false,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_EXPORT_JOB.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };


        case TYPES.FETCH_EXPORT_JOB_SALES_ORDERS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                salesOrderResponse: defaultState.salesOrderResponse
            };
        case TYPES.FETCH_EXPORT_JOB_SALES_ORDERS.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                salesOrderResponse: action.salesOrderResponse
            };
        case TYPES.FETCH_EXPORT_JOB_SALES_ORDERS.REJECTED:
            return {
                ...state,
                isFetchDataError: true,
                isFetchDataLoading: false,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_EXPORT_JOB_SALES_ORDERS.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };




        case TYPES.FETCH_EXPORT_JOB_DETAILS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                exportJobDetails: defaultState.exportJobDetails
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                exportJobDetails: action.exportJobDetails || defaultState.exportJobDetails
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };


        case TYPES.FETCH_RECONCILIATION_PO_DETAILS.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                reconsiliationPODetails: defaultState.reconsiliationPODetails
            };
        case TYPES.FETCH_RECONCILIATION_PO_DETAILS.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                reconsiliationPODetails: action.reconsiliationPODetails || defaultState.reconsiliationPODetails
            };
        case TYPES.FETCH_RECONCILIATION_PO_DETAILS.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_RECONCILIATION_PO_DETAILS.RESET_ERROR:
            return {
                ...state,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };


        case TYPES.FETCH_EXPORT_JOB_DROPDOWN.PENDING:
            return {
                ...state,
                isFetchDataError: false,
                isFetchDataLoading: true,
                detailsPendingError: '',
                documentDropdownData: defaultState.documentDropdownData
            };
        case TYPES.FETCH_EXPORT_JOB_DROPDOWN.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                documentDropdownData: action.documentDropdownData
            };
        case TYPES.FETCH_EXPORT_JOB_DROPDOWN.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_BOOKING.PENDING:
            return {
                ...state,
                exportDetailsBooking: defaultState.exportDetailsBooking
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_BOOKING.FULFILLED:
            return {
                ...state,
                exportDetailsBooking: action.exportDetailsBooking
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_BOOKING.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };

        case TYPES.FETCH_EXPORT_JOB_DETAILS_CLR.PENDING:
            return {
                ...state,
                exportDetailsClr: defaultState.exportDetailsClr
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_CLR.FULFILLED:
            return {
                ...state,
                exportDetailsClr: action.exportDetailsClr
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_CLR.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };

        case TYPES.FETCH_EXPORT_JOB_DETAILS_CBL.PENDING:
            return {
                ...state,
                exportDetailsCbl: defaultState.exportDetailsCbl
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_CBL.FULFILLED:
            return {
                ...state,
                exportDetailsCbl: action.exportDetailsCbl
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_CBL.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };

        case TYPES.FETCH_EXPORT_JOB_DETAILS_ETS.PENDING:
            return {
                ...state,
                exportDetailsEts: defaultState.exportDetailsEts
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_ETS.FULFILLED:
            return {
                ...state,
                exportDetailsEts: action.exportDetailsEts
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_ETS.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };

        case TYPES.FETCH_EXPORT_JOB_DETAILS_INVOICE.PENDING:
            return {
                ...state,
                exportDetailsCustomerInvoice: defaultState.exportDetailsCustomerInvoice
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_INVOICE.FULFILLED:
            return {
                ...state,
                exportDetailsCustomerInvoice: action.exportDetailsCustomerInvoice
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_INVOICE.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_CHARGES.PENDING:
            return {
                ...state,
                isExportDetailsCostAndRevenueLoading: true,
                exportDetailsCostAndRevenue: defaultState.exportDetailsCostAndRevenue
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_CHARGES.FULFILLED:
            return {
                ...state,
                isExportDetailsCostAndRevenueLoading: false,
                exportDetailsCostAndRevenue: action.exportDetailsCostAndRevenue
            };
        case TYPES.FETCH_EXPORT_JOB_DETAILS_CHARGES.REJECTED:
            return {
                ...state,
                isExportDetailsCostAndRevenueLoading: false,
                isFetchDataError: true,
                detailsPendingError: action.errors
            };
        case TYPES.RESET_EXPORT_JOB_DETAILS:
            return {
                ...state,
                exportJobDetails: EmptyDocumentDetail,
                exportDetailsBooking: defaultState.exportDetailsBooking,
                exportDetailsClr: [],
                exportDetailsCbl: [],
                exportDetailsEts: [],
                exportDetailsCustomerInvoice: []
            };
        case TYPES.SET_EXPORT_JOB_SALES_ORDER_ID:
            return {
                ...state,
                salesOrderId: action.salesOrderId,
            };

        case TYPES.BULK_DOWNLOAD_EXPORT_JOBS.PENDING:
            return {
                ...state,
                isDownloadLoading: true,
                bulkDownloadString: defaultState.bulkDownloadString
            };
        case TYPES.BULK_DOWNLOAD_EXPORT_JOBS.FULFILLED:
            return {
                ...state,
                isDownloadLoading: false,
                bulkDownloadString: action.bulkDownloadString
            };
        case TYPES.BULK_DOWNLOAD_EXPORT_JOBS.REJECTED:
            return {
                ...state,
                isDownloadLoading: false,
                detailsPendingError: action.errors
            };

        case TYPES.SALES_ORDER_EXPORT.PENDING:
            return {
                ...state,
                sendCreateSalesOrderExportResult: null,
            };
        case TYPES.SALES_ORDER_EXPORT.FULFILLED:
            return {
                ...state,
                sendCreateSalesOrderExportResult: action.sendCreateSalesOrderExportResult
            };
        case TYPES.SALES_ORDER_EXPORT.REJECTED:
            return {
                ...state,
                sendCreateSalesOrderExportResult: action.errors
            };

        case TYPES.FETCH_NFTP_BILLABLE.PENDING:
            return {
                ...state,
                isNftpBillableLoading: true,
                nftpBillableResponse: null,
            };
        case TYPES.FETCH_NFTP_BILLABLE.FULFILLED:
            return {
                ...state,
                isNftpBillableLoading: false,
                nftpBillableResponse: action.nftpBillableResponse,
            };
        case TYPES.FETCH_NFTP_BILLABLE.REJECTED:
            return {
                ...state,
                isNftpBillableLoading: false,
                nftpBillableResponse: null,
            };

        default:
            return state;
    }
};
